import React, { ReactNode } from 'react';
import { ControlLabel, FormGroup } from 'react-bootstrap';

const CheckboxGroup = ({
  children,
  errorText,
  label,
}: {
  children: ReactNode;
  errorText?: string;
  label?: string;
}) => (
  <FormGroup validationState={errorText ? 'error' : null}>
    {label && <ControlLabel>{label}</ControlLabel>}
    {children}
    {errorText && <span className="help-block">{errorText}</span>}
  </FormGroup>
);

export default CheckboxGroup;
